module.exports = __webpack_public_path__ + "media/photo/component37-e6a515ff.png";